import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {StateSnackBarService} from "../services/state-snack-bar.service";

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const snackbarService = inject(StateSnackBarService);

  if (authService.isAdmin()) {
    return true;
  } else {
    router.navigate(['']);
    snackbarService.error({message: 'Du bist nicht berechtigt, auf diese Seite zuzugreifen.', icon: 'shield'})
    return false;
  }
};
